import './SharedQuestion';
import './TextSharedQuestion';
import './EmailSharedQuestion';
import './LikertScaleSharedQuestion';
import './PageSharedQuestion';
import './PageDynamicSharedQuestion';
import './StaticSharedQuestion';
import './SelectSharedQuestion';
import './SelectNumericSharedQuestion';
import './CheckboxSharedQuestion';
import './RadioSharedQuestion.ts';
import './RadioGridSharedQuestion.ts';
import './RateSharedQuestion.ts';
import './ForceRankSharedQuestion.ts';
import './DragAndDropSharedQuestion.ts';
import './UploadSharedQuestion.ts';
import './ReviewSharedQuestion.ts';
import './SubmitSharedQuestion.ts';